/* eslint-disable no-new */
import { UpError } from '../Error/UpError';
import Logger from '../Logger/Logger';
import LargeBookingViewModel from '../Models/LargeBookingViewModel';
import { appSettingsRepository } from '../Repositories/AppSettingsRepository';
import { sessionRepository } from '../Repositories/SessionRepository';
import { PromiseFail, PromiseResponse, PromiseSuccess } from '../Types/PromiseResponse';
import HttpService from './HttpService';

const logger = Logger.Create('LargeBookingService');

/**
 * Service for handling Large Booking requests.
 */
export default class LargeBookingService
{
  /**
   * Get.
   */
  public static async get(token: string): Promise<PromiseResponse<LargeBookingViewModel>>
  {
    const url = `${window.config.TAKEAWAY_URL}/${token}.json`;

    return HttpService.tokenlessGet<LargeBookingViewModel>(url, true)
      .then((data: LargeBookingViewModel) => PromiseSuccess(data))
      .catch((error) =>
      {
        const message = `Failed to retrieve the data for large booking id: ${token} due to the following issue:\n\n${JSON.stringify(error)}`;
        logger.fatal(message);
        return PromiseFail(message);
      });
  }
}
